import { render } from "./EditStakeModal.vue?vue&type=template&id=1ae0bb6a"
import script from "./EditStakeModal.vue?vue&type=script&lang=js"
export * from "./EditStakeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__